import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import CasinoSearch from 'components/Casino/components/CasinoSearch';
import CategoryFilter from 'components/Casino/components/CategoryFilter';

const CasinoNavigation = ({
  classNames,
  gamesLoading,
  isSearchActive,
  setIsSearchActive,
  setShowFavorites,
  showFavorites,
}) => {
  const casinoNavigationClassName = cx('casino-navigation', classNames);

  return (
    <div className={casinoNavigationClassName}>
      {isSearchActive ? (
        <CasinoSearch
          isSearchActive={isSearchActive}
          loading={gamesLoading}
          setIsSearchActive={setIsSearchActive}
        />
      ) : (
        <CategoryFilter
          setIsSearchActive={setIsSearchActive}
          setShowFavorites={setShowFavorites}
          showFavorites={showFavorites}
        />
      )}
    </div>
  );
};

CasinoNavigation.propTypes = {
  classNames: PropTypes.string,
  gamesLoading: PropTypes.bool,
  isSearchActive: PropTypes.bool,
  setIsSearchActive: PropTypes.func,
  setShowFavorites: PropTypes.func,
  showFavorites: PropTypes.func,
};

export default CasinoNavigation;
